import { SERVICE_PAYMENT } from '@/services';
import { CONSTANTS, HELPERS } from '@/utils';
import store from 'store';
import { ACTION_ACTIVITY } from '../activity/activity.action';
import { TYPES_AUTH } from '../auth/auth.types';
import { TYPES_PAYMENT } from './payment.types';

const submitPayment = (
  uuid,
  activeVoucher,
  productType,
  paymentMethod,
  itemData,
  quantity,
  subscribedUuid,
  subscribedType,
  userName,
  userPhone,
  userEmail,
  idempotencyKey,
  callback,
  fbp = null,
  fbc = null
) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));
    dispatch({ type: TYPES_PAYMENT.SET_SUBMIT_PAYMENT_LOADING, isLoading: true });

    SERVICE_PAYMENT.submitPayment(
      uuid,
      activeVoucher,
      productType,
      paymentMethod,
      itemData,
      quantity,
      subscribedUuid,
      subscribedType,
      userName,
      userPhone,
      userEmail,
      idempotencyKey,
      (res) => {
        dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
        dispatch({ type: TYPES_PAYMENT.SET_SUBMIT_PAYMENT_LOADING, isLoading: false });

        if (res.error) {
          HELPERS.showNotificationServiceError(res.error);
          return;
        }

        if (res.payload.token && res.payload.user) {
          store.set(CONSTANTS.AUTH_TOKEN, res.payload.token);

          dispatch({
            type: TYPES_AUTH.LOGIN,
            profile: res.payload.user,
            token: res.payload.token,
          });
        }

        const isNotNewUser = res.payload.token === null;
        const isUserNotLogin = userEmail && userPhone && userName;
        const hasGuestAccessToken = res.payload && res.payload.guest_access_token;

        if (isUserNotLogin && isNotNewUser && !hasGuestAccessToken) {
          HELPERS.showNotification(
            'Pesanan berhasil dibuat. Silakan login untuk melihat detail transaksi dan melakukan pembayaran'
          );
        } else if (isUserNotLogin && hasGuestAccessToken) {
          HELPERS.showNotification(
            'Pesanan Anda telah kami terima dan sedang diproses. Anda akan segera diarahkan ke halaman status transaksi.',
            'info'
          );
        }

        dispatch({
          type: TYPES_PAYMENT.SUBMIT_PAYMENT,
          payload: res.payload,
          error: res.error,
        });

        callback(res.payload);
      },
      fbp,
      fbc
    );
  };
};

const getVoucherCode = (voucherCode) => {
  return (dispatch) => {
    dispatch({ type: TYPES_PAYMENT.SET_VOUCHER_CODE_LOADING, isLoading: true });
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));

    SERVICE_PAYMENT.getVoucherCode(voucherCode, (res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      if (res.error) HELPERS.showNotificationServiceError(res.error);

      dispatch({
        type: TYPES_PAYMENT.GET_VOUCHER_CODE,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

const getBankAccounts = () => {
  return (dispatch) => {
    dispatch({ type: TYPES_PAYMENT.SET_BANK_ACCOUNTS_LOADING, isLoading: true });
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));

    SERVICE_PAYMENT.getBankAccounts((res) => {
      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));
      if (res.error) HELPERS.showNotificationServiceError(res.error);

      dispatch({
        type: TYPES_PAYMENT.GET_BANK_ACCOUNTS,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

const resetVoucherCode = () => {
  return (dispatch) => {
    dispatch({
      type: TYPES_PAYMENT.GET_VOUCHER_CODE,
      payload: null,
      error: null,
    });
  };
};

const confirmTransfer = (invoiceNumber, formData, callback) => {
  return (dispatch) => {
    dispatch(ACTION_ACTIVITY.showTopLoadingBar(true));
    dispatch({ type: TYPES_PAYMENT.SET_UPLOAD_RECEIPT_LOADING, isLoading: true });

    SERVICE_PAYMENT.confirmTransfer(invoiceNumber, formData, (res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);

      dispatch(ACTION_ACTIVITY.showTopLoadingBar(false));

      if (res.error) HELPERS.showNotificationServiceError(res.error);

      if (callback) callback(res);

      dispatch({
        type: TYPES_PAYMENT.PUT_UPLOAD_RECEIPT,
        payload: res.payload,
        error: res.error,
      });
    });
  };
};

const cancelPayment = (invoiceNumber, callback) => {
  return (dispatch) => {
    dispatch({ type: TYPES_PAYMENT.SET_CANCEL_PAYMENT_LOADING, isLoading: true });

    SERVICE_PAYMENT.cancelPayment(invoiceNumber, (res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);
      if (callback) callback(res);
      dispatch({ type: TYPES_PAYMENT.SET_CANCEL_PAYMENT_LOADING, isLoading: false });
    });
  };
};

const statusPayment = (invoiceNumber, callback) => {
  return (dispatch) => {
    dispatch({ type: TYPES_PAYMENT.STATUS_PAYMENT, isLoading: true });

    SERVICE_PAYMENT.statusPayment(invoiceNumber, (res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);
      if (callback) callback(res);
      dispatch({ type: TYPES_PAYMENT.STATUS_PAYMENT, isLoading: false });
    });
  };
};

const enrollCourse = (uuid, callback) => {
  return (dispatch) => {
    dispatch({ type: TYPES_PAYMENT.ENROLL_COURSE, isLoading: true });

    SERVICE_PAYMENT.enrollCourse(uuid, (res) => {
      if (res.error) HELPERS.showNotificationServiceError(res.error);
      if (callback) callback(res);
      dispatch({ type: TYPES_PAYMENT.ENROLL_COURSE, isLoading: false });
    });
  };
};

export const ACTION_PAYMENT = {
  getBankAccounts,
  confirmTransfer,
  submitPayment,
  getVoucherCode,
  resetVoucherCode,
  cancelPayment,
  statusPayment,
  enrollCourse,
};
